module.exports = __webpack_public_path__ + "img/icon3.f25c9188.png";